import React, { useEffect, useState } from 'react';
import { Table, SearchInput } from 'components';
import { FormDetail } from './form-detail';
import { Box } from '@mui/material';
import { BsPlus } from 'react-icons/bs';
import ApiServices from 'services';
import { Columns } from './columns';
import { ContainerHeader, ButtonAdd } from './styles';

function ContractTypePage() {
  const [contractTypeList, setContractTypeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const initData = async () => {
    setLoading(true);
    try {
      const { data } = await ApiServices.getContractTypes();
      setContractTypeList(data || []);
    } catch (err) {
      console.warn('initData - get Contract Types', err);
    }
    setLoading(false);
  };
  useEffect(() => {
    initData();
  }, []);

  const deleteItem = async (row) => {
    setLoading(true);
    try {
      const res = await ApiServices.deleteContractType(row.id);
      if (res) {
        window.UIMessage?.success('Xóa thành công');
        initData();
      }
    } catch (err) {
      window.UIMessage?.error('Xóa thất bại !!!');
      console.warn('deleteContractType', err);
    }
    setLoading(false);
  };

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <SearchInput sx={{ mr: 2 }} maxWidth={400} />
      </ContainerHeader>
      <ButtonAdd
        variant="contained"
        size="small"
        startIcon={<BsPlus />}
        onClick={() => setSelected({ isNew: true })}
      >
        Thêm mới
      </ButtonAdd>
    </>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Table
        rows={contractTypeList}
        headCells={Columns(deleteItem)}
        onClickDetail={(row) => setSelected(row)}
        title="Loại hợp đồng"
        loading={loading}
        renderHeader={renderHeader}
      />
      <FormDetail {...{ selected, setSelected, initData }} />
    </Box>
  );
}
export { ContractTypePage };
